import { removeHTMLTags } from '@/utils/util'

export function getReadingTime(html: string): number {
  if (!html) return 1
  const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()
  const words = text.split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.round(words / 200))
}

export function getExcerpt(html: string, max: number = 180): string {
  if (!html) return ''
  const text = removeHTMLTags(html).trim()
  return text.length > max ? text.slice(0, max).trim() + '…' : text
}
